import React from "react";
import classes from "./CheckBox.module.css";

const CheckBox = ({ checked, onChecked, onRemoveChecked, children, value, checkBoxColor, disabled }) => {

    const handleChange = (e) => {
        console.log("INPUT CAHNGE")
        e.target.checked ?
            onChecked(value) :
            onRemoveChecked(value)
    }

    return (<div className={classes.CheckBox}>
        <input
            disabled={disabled}
            type={"checkbox"}
            checked={checked}
            name={value}
            onChange={handleChange}
            className={`${classes.CheckBoxInput} ${checked && classes.Checked} ${checkBoxColor == "gray" && classes.GrayCheckBoxInput} `}>
        </input>
        <div className={classes.Text}>{children}</div>
    </div>)
}
export default CheckBox;